import { useState } from 'react';
import { DefaultButton, TextField, ComboBox, IComboBoxOption } from '@fluentui/react';
import { useIntl } from 'react-intl';
import styles from './NewRoleCard.module.scss';

interface SearchResult {
  Job: string;
  Company: string;
}

interface NewRoleCardProps {
  onSubmit: (organisation: string, role: string) => void;
  onCancel: () => void;
  onSearch: (searchText: string) => SearchResult[];
}

export const NewRoleCard: React.FC<NewRoleCardProps> = ({ onSubmit, onCancel, onSearch }) => {
  const intl = useIntl();
  const [role, setRole] = useState('');
  const [organisation, setOrganisation] = useState('');
  const [searchResults, setSearchResults] = useState<IComboBoxOption[]>([]);

  const handleSearch = (searchText: string) => {
    const results = onSearch(searchText);
    const options = results.map(item => ({
      key: `${item.Job}-${item.Company}`,
      text: `${item.Job} at ${item.Company}`,
      data: item,
    }));
    setSearchResults(options);
  };

  const handleSearchSelect = (option?: IComboBoxOption) => {
    if (option?.data) {
      onSubmit(option.data.Company, option.data.Job);
    }
  };

  return (
    <div className={styles.cardContainer}>
      <ComboBox
        label={intl.formatMessage({ id: 'newRoleCard.input.role.label' })}
        options={searchResults}
        onChange={(_: unknown, option?: IComboBoxOption) => {
          if (option) {
            handleSearchSelect(option);
          }
        }}
        onInputValueChange={(newValue: string) => {
          handleSearch(newValue || '');
          setRole(newValue || '');
        }}
        allowFreeform={true}
        text={role}
        required
        openOnKeyboardFocus={true}
        autoComplete="off"
      />

      <TextField
        label={intl.formatMessage({ id: 'newRoleCard.input.organisation.label' })}
        value={organisation}
        onChange={(_, newValue) => setOrganisation(newValue || '')}
        required
      />

      <div className={styles.buttonContainer}>
        <DefaultButton onClick={onCancel}>{intl.formatMessage({ id: 'newRoleCard.button.cancel' })}</DefaultButton>
        <DefaultButton onClick={() => onSubmit(organisation, role)} disabled={!role || !organisation}>
          {intl.formatMessage({ id: 'newRoleCard.button.add' })}
        </DefaultButton>
      </div>
    </div>
  );
};
